import React from 'react';
import { Snackbar } from '@mui/material';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import { useTranslation } from 'react-i18next';
import '../translations/i18n';
import { useSelector } from 'react-redux';
import { useLayout } from '../hooks/layout';

const messages = {
  "BAD-EMAIL": "onboarding_signIn_error_invalidEmail",
  "EMAIL-CONFLICT": "onboarding_signUp_error_alreadyRegistered",
  "BAD-PASSWORD": "onboarding_signIn_error_invalidPassword",
  "BAD-FIRST-NAME": "profile_edit_error_invalidFirstName",
  "BAD-LAST-NAME": "profile_edit_error_invalidLastName",
  "BAD-PHONE": "profile_edit_error_invalidPhone",
  "BAD-FLAG-PROFILE": "onboarding_signUp_error_invalidProfile",
  "BAD-CREDENTIALS": "onboarding_signIn_error_badCredentials",
  "BAD-BIRTHDATE": "profile_edit_error_invalidBirthdate",
  "EMAIL-NOT-FOUND": "onboarding_forgotPassword_error_emailNotFound"
}

const Alert = React.forwardRef(function Alert(
  props,
  ref,
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function Message() {

  const { t } = useTranslation();
  const { error, success } = useSelector((state) => state.layout);
  const { showError, showSuccess } = useLayout();

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    if(error) {
      showError(false);
    }
    if(success) {
      showSuccess(false);
    }
  };

  return (
    <Snackbar open={Boolean(error) || Boolean(success)} autoHideDuration={6000} onClose={handleClose}>
      <Alert onClose={handleClose} severity={success ? 'success' : 'error'}>
        { success && <>{success.message}</>}
        { error && <>{Boolean(messages[error.error_code]) ? t(messages[error.error_code]) : error.error_message}</>}
      </Alert>
    </Snackbar>
  );
}